var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menuContainer"},[_c('p',{staticClass:"title"},[_vm._v("客户服务")]),_c('el-menu',{staticClass:"el-menu-demo",attrs:{"default-active":_vm.activeProduct,"mode":"vertical","router":"","text-color":"#333"}},[_c('el-menu-item',{attrs:{"index":"/customerService/exchangeRate"}},[_vm._v("外汇牌价")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }